'use client';

import Link from '@eliadmin/core/src/components/link';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Button } from '../ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { Carousel } from '../ui/carousel';
import { BlogCard } from '@eliadmin/core/src/components/blog/blog-card';

export function Blogs({
  blogs,
  title,
  className,
}: {
  blogs: Blog[];
  title: string;
  className?: { section?: string };
}) {
  const { t } = useTranslations();

  const options = {
    align: 'start' as const,
  };

  return (
    <section
      className={cn(
        'custom-section',
        'gap-8 py-[30px] pr-0 sm:gap-10 sm:pb-24 sm:pr-4 sm:pt-12 lg:gap-12 lg:pb-32 lg:pt-16',
        className?.section,
      )}
    >
      <div
        className={cn('custom-container', 'flex items-center justify-between gap-4 pr-4 sm:pr-0')}
      >
        <Heading title={title} />
        <Button asChild variant={'dark'} className="hidden sm:flex">
          <Link prefetch={false} href={ROUTES.BLOG()}>
            {t('text2000')}
          </Link>
        </Button>
      </div>
      <div className={cn('custom-container')}>
        <Carousel
          options={options}
          className={{
            container: 'w-full gap-4 sm:gap-4 lg:gap-6',
            wrapper: 'w-full',
            slide: 'w-full max-w-[320px] sm:max-w-[360px] lg:max-w-[384px]',
            main: 'w-full',
          }}
          slides={blogs.map(blog => (
            <BlogCard blog={blog} key={blog.slug} />
          ))}
        />
      </div>
      <div className={cn('custom-container', 'flex pr-4 sm:hidden')}>
        <Button asChild variant={'dark'} className="w-full">
          <Link prefetch={false} href={ROUTES.BLOG()}>
            {t('text2000')}
          </Link>
        </Button>
      </div>
    </section>
  );
}
